import React from 'react';

import AppErrorBoundary from './AppErrorBoundary';
import AppErrorFallback from './AppErrorFallback';

const AppErrorBoundaryWithFallback: React.FC = ({ children, ...rest }) => {
  return (
    <AppErrorBoundary
      fallbackRender={({ error }) => (
        <AppErrorFallback error={error} {...rest} />
      )}
    >
      {children}
    </AppErrorBoundary>
  );
};

export default AppErrorBoundaryWithFallback;
